@let isMenuOpenValue = isMenuOpen();

<header
  #header
  class="web-header"
  [ngClass]="{
    'web-header--open-menu': isMenuOpenValue,
    'web-header--close-menu': !isMenuOpenValue,
    'web-header--animated': menuToggled(),
  }"
>
  <div class="web-header__inner">
    <div class="web-header__inner-left">
      <a href="/" data-testid="landing-logo">
        <fr8bot-web-logo class="web-header__inner-left-logo" />
      </a>

      <nav class="web-header__inner-left-nav">
        <fr8bot-web-menu-button
          data-testid="landing-nav-shippers"
          link="/shippers"
          [isSelected]="isShippersActive()"
        >
          {{ 'landing.header.forShippers' | translate }}
        </fr8bot-web-menu-button>

        <fr8bot-web-menu-button
          data-testid="landing-nav-drivers"
          link="/drivers"
          [isSelected]="isDriversActive()"
        >
          {{ 'landing.header.forDrivers' | translate }}
        </fr8bot-web-menu-button>
      </nav>
    </div>

    <div class="web-header__inner-right">
      <fr8bot-ui-button
        size="small"
        type="secondary"
        data-testid="landing-sign-in"
        (click)="signIn()"
        class="web-header__inner-right-shipNowButtonDesktop"
      >
        {{ 'landing.header.signIn' | translate }}
      </fr8bot-ui-button>

      <fr8bot-ui-button
        size="small"
        type="secondary"
        data-testid="landing-sign-in"
        (click)="signIn()"
        class="web-header__inner-right-shipNowButtonMobile"
      >
        <!--        TODO: home and shipper - customer cabinet-->
        <!--        driver - carrier cabinet-->
        {{ 'landing.header.signIn' | translate }}
      </fr8bot-ui-button>

      <fr8bot-ui-button
        size="small"
        type="primaryCut"
        data-testid="landing-create-account"
        (click)="createAccount()"
        class="web-header__inner-right-shipNowButtonDesktop"
      >
        {{ 'landing.header.createAccount' | translate }}
      </fr8bot-ui-button>

      <fr8bot-ui-button
        size="small"
        type="primary"
        data-testid="landing-create-account"
        (click)="createAccount()"
        class="web-header__inner-right-shipNowButtonMobile"
      >
        <!--        TODO: home and shipper - customer cabinet-->
        <!--        driver - carrier cabinet-->
        {{ 'landing.header.createAccount' | translate }}
      </fr8bot-ui-button>

      <button
        data-testid="landing-menu-toggle"
        type="button"
        class="web-header__inner-right-menu"
        [attr.aria-label]="'landing.header.menu' | translate"
        [attr.aria-expanded]="isMenuOpenValue"
        [ngClass]="{
          'web-header__inner-right-menu--open': isMenuOpenValue,
        }"
        (click)="openMenu()"
      >
        <div class="web-header__inner-right-menu__inner">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </button>
    </div>
  </div>

  <div class="web-header--open-menu__inner">
    <div>
      <fr8bot-web-logo />
    </div>

    <div class="web-header--open-menu__inner-buttons">
      <fr8bot-web-menu-button-menu
        data-testid="landing-menu-home"
        href="/"
        [isSelected]="isHomeActive()"
      >
        {{ 'landing.header.home' | translate }}
      </fr8bot-web-menu-button-menu>

      <fr8bot-web-menu-button-menu
        data-testid="landing-menu-shippers"
        href="/shippers"
        [isSelected]="isShippersActive()"
      >
        {{ 'landing.header.forShippers' | translate }}
      </fr8bot-web-menu-button-menu>

      <fr8bot-web-menu-button-menu
        data-testid="landing-menu-drivers"
        href="/drivers"
        [isSelected]="isDriversActive()"
      >
        {{ 'landing.header.forDrivers' | translate }}
      </fr8bot-web-menu-button-menu>
    </div>

    <div class="web-header--open-menu__inner-action">
      <fr8bot-ui-button
        class="web-header--open-menu__inner-action-button"
        data-testid="landing-menu-create-account"
        size="large"
        type="primaryCut"
        (click)="createAccount()"
      >
        {{ 'landing.header.shipNow' | translate }}
        <fr8bot-ui-icon postfix-icon name="arrow-right-16" [size]="16" />
      </fr8bot-ui-button>
    </div>
  </div>
</header>
